import { FeatureIdEnum } from '../../enums';

import { AppRouteConfig } from '../../models';

import { IndexList } from '../../views';

import { ROUTER_CONSTS } from '../router.consts';

export const INDEX_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes.index,
    path: 'index',
    component: IndexList,
    meta: {
      featureId: FeatureIdEnum.INDEX,
      style: {
        removeContentPadding: true
      }
    }
  }
];
